import { Button } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'

const Unauthorized: React.FC = () => {
    const navigate = useNavigate()

    const goBack = () => navigate(-1)

    return (
        <div className="container-fluid">
            <div className="text-center p-5">
                <div className="error mx-auto" data-text={403}>
                    403
                </div>
                <p className="lead mb-5">Unauthorized</p>
                <p className="mb-0">
                    You do not have access to the requested page.
                </p>
                <Button onClick={goBack} variant="secondary" className="mt-5">
                    ← Go Back
                </Button>
            </div>
        </div>
    )
}

export default Unauthorized
